import dinny from '../assets/img/ux/dinny.jpg'
import fixntic from '../assets/img/ux/fixntic.jpg'
import bbb from '../assets/img/ux/bbb.jpg'
import hub from '../assets/img/ux/hub.jpg'
import nubela from '../assets/img/branding/nubela.jpg'
import rs from '../assets/img/frontend/rs.jpg'
import cuentos from '../assets/img/creative/cuentos.jpg'

export const ImagesData = {
  //UX
  'dinny': dinny,
  'fixntic': fixntic,
  'bbb': bbb,
  'hub': hub,
  //Creative
  'cuentos': cuentos,
  //Branding
  'nubela': nubela,
  //Frontend
  'rs': rs,
};

export default ImagesData;
